export default "You are a gang of thieves and your target is a casino in Copenhagen. Can you get to the contents of the safe before the police arrives?";